import React from "react";
import notify from "devextreme/ui/notify";
import Form, { SimpleItem, Label, GroupItem } from "devextreme-react/form";
import api from "../../api-axios";
import UserInfo from "../../UserInfo";
import { Button } from "devextreme-react";
import { LoadPanel } from "devextreme-react/load-panel";
import { criarImovelBciDs } from "../../DataSources";
import ShowError from "../../AppServices";

export default class ImovelBciFatores extends React.Component {
  constructor() {
    super();
    this.state = { fatores: [] };
    this.imovelBciDs = criarImovelBciDs();

    this.criarLookupFator = this.criarLookupFator.bind(this);

    this.ok = this.ok.bind(this);
    this.cancelando = this.cancelando.bind(this);
  }

  componentDidMount() {
    if (this.props.match.params.id !== undefined) {
      this.imovelBciDs
        .byKey(this.props.match.params.id)
        .then((data) => {
          if (data !== undefined && data.scores) {
            let scoreList = {};
            for (let score of data.scores) {
              if (score.opcao)
                scoreList[`fat${score.opcao.scoreId}`] = score.opcaoId;
            }
            this.setState({ ...scoreList });
          } else {
            notify("Imóvel BCI não encontrado.", "error");
            this.props.history.push("/imovel-bci");
          }
        })
        .catch((error) => {
          ShowError(error.response.data);
          notify(error, "error", 2000);
          this.props.history.goBack();
        });

      api
        .get(
          `bciimovel/${UserInfo.getPrefeitura()}/scores/${
            this.props.match.params.id
          }`
        )
        .then((response) => {
          if (response !== undefined) {
            this.setState({ fatores: response.data });
          }
        });
    } else {
      notify("Não foi possível localizar o imóvel BCI", "error");
      this.props.history.push("/imovel-bci");
    }
  }

  criarLookupFator(fator) {
    let fatorOptions = {
      editorType: "dxSelectBox",
      searchEnabled: false,
      placeholder: "Escolher...",
      dataSource: fator.opcoes,
      showClearButton: true,
      valueExpr: "opcaoId",
      displayExpr: "opcaoDescricao",
    };

    return (
      <SimpleItem
        key={fator.categoriaId}
        dataField={"fat" + fator.categoriaId}
        editorType={"dxSelectBox"}
        editorOptions={fatorOptions}
      >
        <Label text={fator.categoria} />
      </SimpleItem>
    );
  }

  ok(flag) {
    let opcoesFatores = [];
    for (let fator of this.state.fatores) {
      if (this.state["fat" + fator.categoriaId]) {
        opcoesFatores.push({
          categoriaId: fator.categoriaId,
          opcaoSelecionada: this.state["fat" + fator.categoriaId],
        });
      }
    }

    const entidade = {
      imovelId: this.props.match.params.id,
      scores: opcoesFatores,
      prefeituraId: UserInfo.getPrefeitura(),
    };

    api
      .put("/bciimovel/inserirfatores", entidade)
      .then((response) => {
        if (response.status === 200) {
          notify("Fatores inseridos com sucesso.", "success", 1000);
          if (flag) {
            this.props.history.push("/imovel-bci/novo");
          } else {
            this.props.history.push("/imovel-bci");
          }
        }
      })
      .catch((error) => {
        ShowError(error.response.data);
        notify(error, "error", 2000);
      });
  }

  cancelando() {
    this.props.history.push("/imovel-bci");
  }

  render() {
    return (
      <React.Fragment>
        <div className={"content-block dx-card responsive-paddings"}>
          <div style={{ display: "flex", justifyContent: "center" }}>
            <Button
              className="botaoImovel"
              icon="home"
              text="Imóvel"
              onClick={() =>
                this.props.history.push(
                  "/imovel-bci/editar/" + this.props.match.params.id
                )
              }
            />
            <Button
              className="botaoImovel"
              icon="chart"
              text="Fatores Corretivos"
              width={200}
            />
          </div>
          <br />
          <br />
          <h3>Cadastrar Fatores</h3>
          <Form formData={this.state} colCount={3} labelLocation="top">
            <GroupItem colSpan={3} colCount={3} caption="">
              {this.state.fatores.length > 0 ? (
                this.state.fatores.map((x) => this.criarLookupFator(x))
              ) : (
                <div id="fatores" style={{ width: "100%", height: "300px" }}>
                  <LoadPanel
                    shadingColor="rgba(0,0,0,0.4)"
                    position={{ of: "#fatores" }}
                    visible={true}
                    showIndicator={true}
                    shading={true}
                    showPane={true}
                  />
                </div>
              )}
            </GroupItem>
          </Form>
          <div
            style={{
              marginTop: "10px",
              display: "flex",
              gap: "15px",
              justifyContent: "center",
            }}
          >
            <Button
              width={120}
              text="Salvar"
              type="success"
              onClick={() => this.ok(false)}
            />
            <Button
              width={160}
              text="Salvar e criar novo"
              type="default"
              onClick={() => this.ok(true)}
            />
            <Button
              width={120}
              type={"danger"}
              text="Fechar"
              onClick={this.cancelando}
            />
          </div>
        </div>
      </React.Fragment>
    );
  }
}
